import {AfterViewInit, Component, OnInit, inject, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {EventsManager} from 'src/app/services/events.manager';
import {GetDocumentDetailRequestInterface} from 'src/app/interfaces/document-request.interface';
import {PlansService} from 'src/app/services/plans.service';
import {NgFor, NgIf} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-summary-discounts',
  templateUrl: './summary-discounts.component.html',
  styleUrl: './summary-discounts.component.scss',
  imports: [FormsModule, NgFor, NgIf]
})

export class SummaryDiscountsComponent implements OnInit, AfterViewInit {
  private _plansService = inject(PlansService);
  private _activatedRoute = inject(ActivatedRoute);
  private _destroyRef = inject(DestroyRef);
  public eventsManager = inject(EventsManager);

  public feeUrl: string = '';
  public discountUrl: string = '';
  public stateChosen: boolean = false;
  public currentState: any = {};
  public selectedState: string = '';
  public stateAbbr: string = '';
  public showIfPurchaseIsNotAdha: boolean = false;
  public mapImagePath: string = 'assets/images/coverage-map.png';

  public ngOnInit(): void {
    if (this.eventsManager.purchaseIsADHA) {
      this.stateAbbr = 'ADHA';
    }

    const url: string = this._activatedRoute.snapshot.url.join('|');
    if (url.includes('adha')) {
      this.stateAbbr = 'ADHA';
      this.showIfPurchaseIsNotAdha = true;
      this.stateChosen = true;
      this.eventsManager.purchaseIsADHA = true;
      this.eventsManager.setHideHeader(true);
      this.getPlanDocuments();
      this.mapImagePath = 'assets/images/adha-coverage-map.png';
    }

    if (sessionStorage['state'] && !this.showIfPurchaseIsNotAdha) {
      this.currentState = JSON.parse(sessionStorage['state']);
      this.selectedState = this.currentState.name;
      this.stateAbbr = this.currentState.abbr;
      this.getPlanDocuments();
    }
  }

  public ngAfterViewInit() {
    this.scrollMe();
  }

  public stateChanged(state: any) {
    if (state.target.value !== 'none') {
      state.target.blur();
      this.stateAbbr = state.target.value;
      this.getPlanDocuments();
    } else {
      this.stateChosen = false;
    }
  }

  public buildUrls(state: string) {
    const urls: any = state.split(',');
    this.feeUrl = urls[1];
    this.discountUrl = urls[0];
    this.stateChosen = true;
  }

  public openUrl(url: string) {
    if (url == 'fees') {
      window.open(this.feeUrl);
    } else {
      window.open(this.discountUrl);
    }
  }

  public getPlanDocuments() {
    const year: string = new Date().getFullYear().toString();
    const docReq: GetDocumentDetailRequestInterface = {category:'PlanDetails,WebsiteFlyers', brand:'sgdp', year:year, organizationId:this.eventsManager.orgId, coverageLevelName:'', planName:'', state:this.stateAbbr};
    this._plansService.getDocumentDetails(docReq)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((response) => {
        this.buildUrls(response);
        this.scrollMe();
      });
  }

  public scrollMe() {
    window.scrollTo(0, -window.scrollY);
  }
}
